export default [
  {
    reducerKey: 'countries',
    sagaKey: 'countriesSaga',
    routeKeys: ['registration'],
    importReducer: () => import(/* webpackChunkName: "domain-auth" */ 'modules/Countries/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-auth" */ 'modules/Countries/store/saga'),
  },
]
